import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EditorService } from 'src/app/shared/services/editor.service';
import { LckrService } from 'src/app/shared/services/lckr.service';
import { ThemingService } from 'src/app/shared/services/theming.service';

@Component({
  selector: 'app-dashboard-settings',
  templateUrl: './dashboard-settings.component.html',
  styleUrls: ['./dashboard-settings.component.scss']
})
export class DashboardSettingsComponent implements OnInit {

  disable : boolean = false
  constructor(private toastr: ToastrService, 
    private themingService: ThemingService,
    private editorService: EditorService,
    private lckrService: LckrService,) {

    let _theme = sessionStorage.getItem("theme");
    if (_theme == "false") {
      this.theme = false
    } else {
      this.theme = true
    }
  }


  theme: boolean = true;
  mySitess: string = '';
  customDomain: string = '';
  settingObj: {
    maxDa: number,
    mySites: string[],
    customDomain: string[],
    type: string
  } = {
      maxDa: 0,
      mySites: [],
      customDomain: [],
      type:""
    }
  maxDA: number = 30;
  urlRegex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
  @Output() settingsData = new EventEmitter<{}>();
  @Input() settings: any;
  @Input() isDashboard2: boolean=false;
  @Input() lid!: string;

  ngOnInit(): void {
    this.themingService.getThemeName().subscribe((res: any) => {
      this.theme = res
    });
    if(!this.isDashboard2){
      let a = JSON.stringify(this.settings);
      this.settings = JSON.parse(a);
      this.settingObj.customDomain = this.settings.customDomain?.length > 0 ? this.settings.customDomain : [];
      this.settingObj.mySites = this.settings.mySites?.length > 0 ? this.settings.mySites : [];
      this.settingObj.maxDa = this.settings.maxDa;
      this.maxDA = this.settings.maxDa > 0 ? this.settings.maxDa : this.maxDA;
      this.disable = this.settings.type == "global" ? true : false;
      this.theme = this.settings.theme == undefined ? true : this.settings.theme
      this.editorService.getSettingData().subscribe((res:any)=>{
        this.settingObj.customDomain = res.customDomain?.length > 0 ? res.customDomain : [];
        this.settingObj.mySites = res.mySites?.length > 0 ? res.mySites : [];
        this.settingObj.maxDa = res.maxDa;
        this.maxDA = res.maxDa > 0 ? res.maxDa : this.maxDA;
        this.disable = res.local_setting == true ? false : true;
      })
    }else{
      this.lckrService.postGlobalSettings({
        "main_type": "individual_lckr_settings",
        "type": "get_local_settings",
        "lid": this.lid
      }).subscribe((res:any)=>{
        this.settingObj.customDomain = res.highlight_domains?.length > 0 ? res.highlight_domains : [];
        this.settingObj.mySites = res.mysite_domains?.length > 0 ? res.mysite_domains : [];
        this.settingObj.maxDa = res.max_da;
        this.maxDA = res.max_da > 0 ? res.max_da : this.maxDA;
        this.disable = res.local_setting == true ? false : true;
      })
    }
    
  }

  addCustomDomain(eventType?: string) {
    if (this.customDomain.search(",") > 0) {
      let splitedURL:any = this.customDomain.toLowerCase().split(',');
      let count = 0;
      splitedURL.forEach((e:any) => {
        let matchRegex = this.isValidURL(e);
        if (!matchRegex) {
          count = count + 1;
        }
      });
      if (count == 0) {
        splitedURL = splitedURL.map((v:any)=>{
          if(this.isValidHttpUrl(v) == true ){
            const url = new URL(v); 
            return url.hostname.replace(/^www\./, "") 
          }else{
            return v.replace(/^www\./, "")
          }
        })
        // if(!this.settingObj.customDomain.includes(this.customDomain)) {
        this.settingObj.customDomain.push(...splitedURL);
        this.settingObj.customDomain = [...new Set(this.settingObj.customDomain)];
        if (this.maxDA <= 30) {
          this.settingObj.maxDa = this.maxDA;
          this.settingsData.emit(this.settingObj);
          this.toastr.success("Settings saved successfull");
        } else {
          this.toastr.error("Max DA should be less than 30");
        }
        this.customDomain = "";
        // }
      } else {
        this.toastr.error("Please enter valid Domains")
      }
    } else {
      if (this.customDomain !== "") {
        let matchRegex = this.isValidURL(this.customDomain);
        if (matchRegex) {
          let url : any = ''
          if(this.isValidHttpUrl(this.customDomain) == true){
            url = new URL(this.customDomain);
            this.settingObj.customDomain.push(url.hostname.replace(/^www\./, ""));
          }else{
            this.settingObj.customDomain.push(this.customDomain.replace(/^www\./, ""));
          }
          // if(!this.settingObj.customDomain.includes(this.customDomain)) {
          this.settingObj.customDomain = [...new Set(this.settingObj.customDomain)];
          if (this.maxDA <= 30) {
            this.settingObj.maxDa = this.maxDA;
            this.settingsData.emit(this.settingObj);
            this.toastr.success("Settings saved successfull");
          } else {
            this.toastr.error("Max DA should be less than 30");
          }
          this.customDomain = "";
          // }
        } else {
          this.toastr.error("Please enter a valid Domain")
        }
      } else {
        if (eventType !== 'focusOut') {
          this.toastr.error("Please enter a Domain")
        }
      }
    }
  }

 isValidHttpUrl(data:any) {
    let url;
    
    try {
      url = new URL(data);
    } catch (_) {
      return false;  
    }
  
    return url.protocol === "http:" || url.protocol === "https:";
  }


  addCustomSites(eventType?: string) {
    if (this.mySitess.search(",") > 0) {
      let splitedURL = this.mySitess.toLowerCase().split(',');
      let count = 0;

      splitedURL.forEach(e => {
        let matchRegex = this.isValidURL(e);
        if (!matchRegex) {
          count = count + 1;
        }
      })
      if (count === 0) {
        splitedURL = splitedURL.map((v:any)=>{
          if(this.isValidHttpUrl(v) == true ){
            const url = new URL(v); 
            return url.hostname.replace(/^www\./, "") 
          }else{
            return v.replace(/^www\./, "")
          }
        })
        this.settingObj.mySites.push(...splitedURL);
        this.settingObj.mySites = [...new Set(this.settingObj.mySites)];
        if (this.maxDA <= 30) {
          this.settingObj.maxDa = this.maxDA;
          this.settingsData.emit(this.settingObj);
          this.toastr.success("Settings saved successfull");
        } else {
          this.toastr.error("Max DA should be less than 30");
        }
        this.mySitess = "";
      } else {
        this.toastr.error("Please enter valid sites URL")
      }
    } else {
      if (this.mySitess !== "") {
        let matchRegex = this.isValidURL(this.mySitess);
        if (matchRegex) {
          let url : any = ''
          if(this.isValidHttpUrl(this.mySitess) == true){
            url = new URL(this.mySitess);
            this.settingObj.mySites.push(url.hostname.replace(/^www\./, ""));
          }else{
            this.settingObj.mySites.push(this.mySitess.replace(/^www\./, ""));
          }
          // if(!this.settingObj.mySites.includes(this.mySitess)) {
         
          this.settingObj.mySites = [...new Set(this.settingObj.mySites)];
          if (this.maxDA <= 30) {
            this.settingObj.maxDa = this.maxDA;
            this.settingsData.emit(this.settingObj);
            this.toastr.success("Settings saved successfull");
          } else {
            this.toastr.error("Max DA should be less than 30");
          }
          this.mySitess = "";
          // }

        } else {
          this.toastr.error("Please enter valid site URL")
        }
      } else {
        if (eventType !== 'focusOut') {
          this.toastr.error("Please enter site URL")
        }
      }
    }
  }
  updateSettings() {
    if (this.maxDA <= 30) {
      this.settingObj.maxDa = this.maxDA;
      this.settingsData.emit(this.settingObj);
      this.toastr.success("Settings saved successfull");
    } else {
      this.toastr.error("Max DA should be less than 30");
    }
  }

  isValidURL(string: string) {
    var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    return (res !== null)
  };
  removeChip(index: number, arg: string) {
    if (arg === "customDomain") {
      this.settingObj.customDomain.splice(index, 1);
    } else {
      this.settingObj.mySites.splice(index, 1);
    }
    if (this.maxDA <= 30) {
      this.settingObj.maxDa = this.maxDA;
      this.settingsData.emit(this.settingObj);
      this.toastr.success("Settings saved successfull");
    } else {
      this.toastr.error("Max DA should be less than 30");
    }
  }

  changeSetting(e:any){
    if(this.disable == false){
      this.editorService.setFlag(false)
    }else{
      this.editorService.setFlag(true)
    }
  }

}
